// extracted by mini-css-extract-plugin
export default {"Container":"Product_Container__Ot14F","title":"Product_title__IiFxj","price":"Product_price__uf7hz","desc":"Product_desc__xHjYg","Image":"Product_Image__M8g1W"};